import React from 'react';
import { MarkerProps } from '../../../../types/map';
import { Marker, Popup } from 'react-leaflet';
import { LatLng } from 'leaflet';

export default function MarkerWithInfoWindow(props: MarkerProps) {
  const { position, icon, infoWindowContent } = props;
  if (!icon) return <></>;
  return (
    <>
      {[-1, 0, 1].map((w, i) => {
        return (
          <Marker
            key={i}
            position={[
              (position as LatLng).lat,
              (position as LatLng).lng + w * 360,
            ]}
            icon={icon}
          >
            {infoWindowContent && (
              <Popup autoClose={false}>{infoWindowContent}</Popup>
            )}
          </Marker>
        );
      })}{' '}
    </>
  );
}
